import ADVERTISERS_API from 'api/advertisers/v1'
import AdvertiserCreateForm from 'modules/Forms/Advertisers/Create'
import React, { useEffect, useMemo, useState } from 'react'
import { useRouteMatch } from 'react-router'
import { useHistory } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { DoublePanelViewLayout } from 'layouts/DoublePanelViewLayout'
import useQueryParams from 'utils/hooks/useQueryParams'

const AdvertiserCreate = () => {
  const pathGen = useGeneratePathI18n()
  const history = useHistory()
  const {
    query: { goBack },
  } = useQueryParams()

  const {
    params: { id },
  } = useRouteMatch()

  const [initialValues, setInitialValues] = useState()

  const advertiserId = useMemo(() => (id !== 'new' ? id : undefined), [id])

  useEffect(() => {
    if (advertiserId) {
      ADVERTISERS_API.fetchById({ id }).then(({ response, error }) => {
        if (!error) {
          setInitialValues({
            advertiser_info: response.data,
          })
        }
      })
    }
  }, [])

  return (
    <DoublePanelViewLayout
      onClose={(e) => {
        e.preventDefault()
        history.push(goBack ?? pathGen(ROUTES.ADVERTISERS))
      }}
    >
      <AdvertiserCreateForm
        advertiserId={advertiserId}
        initialValues={initialValues}
        onClose={() => history.push(goBack ?? pathGen(ROUTES.ADVERTISERS))}
      />
    </DoublePanelViewLayout>
  )
}

export default AdvertiserCreate
